import { defineMessages } from 'react-intl';

/**
 * @internal
 */
export const errorFallbackMessages = defineMessages({
  errorTitleMessage: {
    defaultMessage: 'An error occurred',
    id: 'YTE4r9D1o7r/DV13',
    description:
      'The message shown when a component reaches an invalid state due to an uncaught exception.',
  },
  recoverStateButtonText: {
    defaultMessage: 'Reset',
    id: 'n1zi/yl5dOaxTrfN',
    description:
      'Button text for trying to recover a component from an invalid state.',
  },
});
